// switch — wireframe skin module
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    outline: none;
    min-height: 44px;
    min-width: 44px;
    justify-content: center;
    padding: 0 8px;
  }

  :host([disabled]) {
    cursor: not-allowed;
    opacity: var(--run-wf-disabled-opacity, 0.4);
    pointer-events: none;
  }

  :host(:focus-visible),
  :host([data-focus-visible]) {
    outline: 2px solid var(--run-wf-accent, #94a3b8);
    outline-offset: 2px;
    border-radius: 99px;
  }

  [part="base"] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  [part="track"] {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    border-radius: 99px;
    background: transparent;
    border: 1.5px dashed var(--run-wf-border, #94a3b8);
    box-sizing: border-box;
    flex-shrink: 0;
  }

  :host([checked]) [part="track"] {
    border-style: solid;
    border-color: var(--run-wf-text, #64748b);
    background: var(--run-wf-border, #94a3b8);
  }

  [part="thumb"] {
    position: absolute;
    top: 50%;
    left: 2px;
    transform: translateY(-50%) translateX(0);
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: var(--run-wf-border, #94a3b8);
  }

  :host([checked]) [part="thumb"] {
    transform: translateY(-50%) translateX(22px);
    background: var(--run-wf-text, #64748b);
  }
`;

export function render(host) {
  const existing = host.shadowRoot.querySelector('[part="base"]');
  if (existing) return;
  host.shadowRoot.innerHTML = `
    <span part="base" aria-hidden="true">
      <span part="track">
        <span part="thumb"></span>
      </span>
    </span>
  `;
}
